// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qa_a bhm_sn bhm_va","ForumSearch__img":"qa_b","ForumSearch__searchAdsAndShoppingAds":"qa_c","ForumSearch__results--empty":"qa_e"};